module.exports = __webpack_public_path__ + "static/img/gb-dk.36c64d48.png";